import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43fa64d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-content" }, " 是迄今为止具有大量实践积累且规模最大的等级考试 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_TestIntroduce = _resolveComponent("TestIntroduce")!
  const _component_TestFounder = _resolveComponent("TestFounder")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Banner, {
      title: "全国青少年软件编程等级考试",
      image: _ctx.bannerBg,
      class: "banner-wrap"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["image"]),
    _createVNode(_component_TestIntroduce),
    _createVNode(_component_TestFounder)
  ]))
}